import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileManagerGridComponent } from './file-manager-grid/file-manager-grid.component';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { NewDocumentClientComponent } from './new-document-client/new-document-client.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FileManagerGridComponent,
    NewDocumentClientComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatGridListModule,
    MatMenuModule,
    MatToolbarModule,
    MatButtonModule,
    MatTooltipModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  exports: [
    FileManagerGridComponent,
    NewDocumentClientComponent,
  ]
})
export class FileManagementModule { }
